import { ContractPath } from "../routing/ContractPath";
import { useLink } from "../../useLink";
import { useContract } from "../ContractContext";
import { InfoAlert } from "@teamscheme/alert";
import { ButtonLink } from "@teamscheme/button-link";
import styled from "styled-components";

export function useIsEditable() {
  const contract = useContract();

  return !contract.signature;
}

export function EditableStatusMessage() {
  const isEditable = useIsEditable();
  const link = useLink(ContractPath.preview);

  return !isEditable ? (
    <StyledInfoAlert>
      <p>
        Kontrakten er låst for endringer. Du kan sjekke signeringsstatus, eller
        avbryte signering på siden om din kontrakt.
      </p>
      <ButtonLink variant="secondary" linkTo={link}>
        Sjekk status
      </ButtonLink>
    </StyledInfoAlert>
  ) : null;
}

const StyledInfoAlert = styled(InfoAlert)`
  margin-bottom: ${({ theme }) => theme.spacing.space20};
`;
